import React from "react";
import ActivityLog from "../../components/admin/activityLog";

function AdminActivityLogPage(props) {
  return (
    <div className="admin-page-child-wrapper" style={{ position: "relative" }}>
      <ActivityLog />
    </div>
  );
}

export default AdminActivityLogPage;
